import React, { useState, useEffect } from 'react';
import { Box, Popup, useMedia, Spinner } from '../../components/Boneyard';
import { isInternalUrl } from '../../utils/routeUtils';
import { withValue } from '@g4/automation-hooks';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import tracking from '@g4/g4-analytics';

const propTypes = {
  automationHook: PropTypes.string,
  overlayImageDesktop: PropTypes.string,
  overlayImageResponsive: PropTypes.string,
  overlayLink: PropTypes.string,
  target: PropTypes.string,
  alt: PropTypes.string,
  overlayGAName: PropTypes.string,
  overlayGAPosition: PropTypes.string,
  overlayGALabel: PropTypes.string,
};

const OverlayImg = styled.img`
  min-width: 100px;
  min-height: 100px;
`;

const OverlayWrapper = styled.div`
  visibility: ${props => props.visibility};
`;

const SpinnerWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => (props.fullScreen ? '100vh' : '100%')};
  width: ${props => (props.fullScreen ? '100vw' : '100%')};
  position: ${props => (props.fullScreen ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  z-index: 997;
`;

const OverlayMerchandise = ({
  automationHook,
  overlayImageDesktop,
  overlayImageResponsive,
  overlayLink,
  target,
  alt,
  overlayGAName,
  overlayGAPosition,
  overlayGALabel,
}) => {
  const mq = useMedia();
  const isMobile = mq.lte('md');

  const [isPopupOpen, togglePopupVisibility] = useState(true);
  const hideIcePopup = () => togglePopupVisibility(false);

  const image = isMobile
    ? overlayImageResponsive.split('/').slice(-1)[0]
    : overlayImageDesktop.split('/').slice(-1)[0];

  // We need to pass 'overlayGAName' 'overlayGAPosition' and 'overlayGALabel' as props to CMS content.

  useEffect(() => {
    overlayGAName &&
      image &&
      overlayGAPosition &&
      overlayGALabel &&
      tracking.trackPromoImpressionModalAd({
        creative: image,
        name: overlayGAName,
        promoSource: isInternalUrl(overlayLink) ? 'internal' : 'external',
        position: overlayGAPosition,
      });
  }, [image, overlayGAName, overlayGAPosition, overlayGALabel, overlayLink]);

  const onClickLink = () => {
    overlayGAName &&
      image &&
      overlayGAPosition &&
      overlayGALabel &&
      tracking.trackPromoClickModalAd({
        creative: image,
        name: overlayGAName,
        promoSource: isInternalUrl(overlayLink) ? 'internal' : 'external',
        position: overlayGAPosition,
      });
  };

  const [loaded, setLoaded] = useState(false);

  const popupContent = isMobile
    ? overlayImageResponsive &&
      overlayImageResponsive !== '' && (
        <OverlayWrapper visibility={loaded ? 'visible' : 'hidden'}>
          <OverlayImg
            src={overlayImageResponsive}
            alt={alt}
            isMobile={isMobile}
            onLoad={() => setLoaded(true)}
          />
        </OverlayWrapper>
      )
    : overlayImageDesktop &&
      overlayImageDesktop !== '' && (
        <OverlayWrapper visibility={loaded ? 'visible' : 'hidden'}>
          <OverlayImg
            src={overlayImageDesktop}
            alt={alt}
            isMobile={isMobile}
            onLoad={() => setLoaded(true)}
          />
        </OverlayWrapper>
      );

  return (
    <>
      {
        <Popup
          open={isPopupOpen}
          withDefaultPadding={false}
          onRequestClose={hideIcePopup}
          automationHook={withValue(automationHook, 'ice-pop')}
        >
          <Box borderRadius={10} overflow="hidden">
            <Box
              mt={isMobile ? 3 : 5}
              ml={isMobile ? 2 : 5}
              mr={isMobile ? 2 : 5}
            >
              <Box d="flex" direction={isMobile ? 'column' : 'row'}>
                <Box w={'100%'} d="flex" alignItems="center">
                  <a href={overlayLink} target={target} onClick={onClickLink}>
                    {!loaded && (
                      <SpinnerWrapper fullscreen>
                        <Spinner
                          size="large"
                          appearance="dark"
                          automationHook={withValue(
                            automationHook,
                            'loading-spinner'
                          )}
                          inline
                        />
                      </SpinnerWrapper>
                    )}
                    {popupContent}
                  </a>
                </Box>
              </Box>
            </Box>
          </Box>
        </Popup>
      }
    </>
  );
};
OverlayMerchandise.propTypes = propTypes;

export default OverlayMerchandise;
